import { createContext, Dispatch } from 'react';

type Props = [alert: Snack | null, setAlert: Dispatch<Snack | null>];

const AlertContext = createContext<Props>([null, () => {}]);

export default AlertContext;
